import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '../../../core/translation';
import { FinishProService } from '../../services/finish-pro.service';
import { LoadingProService } from '../../services/loading-pro.service';
import { CertificateService } from '../../../finish/services/certificate.service';
import { MessageService } from '../../../shared/message/message.service';
import { messageTypes } from '../../../finish/models/message-types';
import { CertificateClientResponse, IvCertCircuitDocumentP, OperationDetailR, UserService } from '../../../../app/api';
import { ProfileService } from '../../../core/profile/profile.service';
import { ConfirmModalComponent } from '../../components/modal/confirm-modal/confirm-modal.component';
import { CustomMetadataOperation } from '../../models/operations/metadata';
import { Routes } from '../../models/routes';
import { MatDialog } from '@angular/material/dialog';
import { AvailableOperationTypes } from '../../models/operations/available-operation-types';

@Component({
  selector: 'app-operation-NOTE',
  templateUrl: './operation-NOTE.component.html',
  styleUrls: ['./operation-NOTE.component.scss'],
})
export class OperationNOTEComponent implements OnInit {

  message: Object = {};

  contentNOTE = {
    noteText: '',
    recipient: '',
    publicKey: '',
    operationId: '',
    documentHash: '',
    certInfo: ''
  };

  documents: IvCertCircuitDocumentP[];

  publicKey: string;

  isLoading: boolean = false;

  operationType: string;

  constructor(
    public _translate: TranslateService,
    private _router: Router,
    private _route: ActivatedRoute,
    public _finishProService: FinishProService,
    public _loadingPro: LoadingProService,
    public _certificate: CertificateService,
    public _message: MessageService,
    public _user: UserService,
    public _profile: ProfileService,
    public _dialog: MatDialog) { }

  ngOnInit(): void {
    this.operationType = this._finishProService.operationDetailResponse?.operationType;
    this._loadingPro.setLoader(false);
    this.loadCertificateData();
  }

  ngAfterViewInit(): void {
    this.documents = this._finishProService.documentListResponse;
  }

  loadCertificateData(): void {
    this._loadingPro.setReprocessLoader(true);
    this.certAuth(this._finishProService.operationDetailResponse, this._finishProService.operationDetailResponse.idOperation, false);
  }

  async certAuth(res: OperationDetailR, id: string, qualified: boolean): Promise<void> {
    if (this.operationType === AvailableOperationTypes.QERDS) {
      qualified = true;
    }

    const certData = this._certificate.certData;

    if (certData) {
      this.setData(certData);
      return;
    }

    await this._certificate.certGate();

    this._certificate.getCertificate((data: any) => {
      if (data && !data.error) {
        this.setData(data.data);
      }
      if (data.error) {
        this.message = {
          type: messageTypes.ERROR,
          text: data.error.status ? this._message.renderError(data.error) : 'finish_error_no_certificate'
        };
        this._loadingPro.setLoader(false);
        this._loadingPro.setReprocessLoader(false);
        this._finishProService.operationRequest.hasError = true;
        this._finishProService.operationRequest.error = data.error;
        const route = this._finishProService.getRoutePath();
        this._router.navigate([route], { relativeTo: this._route.parent });
        return;
      }

      let doc = null;
      for (let i = 0; i < res.metadata.length; i++) {
        if (res.metadata[i].key === 'CONTACT_DNI') {
          doc = res.metadata[i].value;
          if (doc) {
            doc = doc.toUpperCase();
            break;
          }
        }
      }
      if (!doc) {
        const dniNif = res.nifUser;
        doc = dniNif ? dniNif.toUpperCase() : null;
      }

      if (doc) {
        if (this._certificate.checkCertificate(doc)) {
          if (res.nameUser === res.mailUser) {
            this.createUser(id, data.data.publicKey);
          }
        } else {
          this._translate.instant('finish_error_wrong_certificate');
          this.message = {
            type: messageTypes.ERROR,
            text: 'finish_error_wrong_certificate'
          };
        }

      }
    }, qualified ? id : null);
  }

  createUser(id: string, publicKey: string): void {
    const req = { idOperation: id, publicKey: publicKey };
    this._user.userPostCreateUserNote(req, this._profile.getToken()).subscribe((res) => { console.log(res) }, () => { });
  }

  setData(data: CertificateClientResponse): void {
    const user = data.parseCertInfo.certinfo.user;
    const org = data.parseCertInfo.certinfo.org;
    let line = '';
    if (user.doc && user.name) {
      line = user.doc + ' - ' + user.name + ' ' + user.surname;
    } else if (org.doc && org.name) {
      line = org.doc + ' - ' + org.name;
    }
    this.publicKey = data.publicKey;
    this.contentNOTE = {
      noteText: this._translate.instant('finish_note_text'),
      recipient: line,
      publicKey: data.publicKey,
      operationId: this._finishProService.operationDetailResponse.idOperation,
      documentHash: this._finishProService.documentListResponse[0].hash,
      certInfo: data.parseCertInfo.certinfo.subject
    };
    this._loadingPro.setReprocessLoader(false);
  }

  async finishOperation(): Promise<void> {
    try {
      this.downloadDocuments();
    } catch (e) {
      this.isLoading = false;
      console.log(e);
    }
  }

  onReject(): void {
    const d = this._dialog.open(ConfirmModalComponent, {
      width: '350px'
    });
    const sub = d.afterClosed().subscribe(async (result) => {
      if (result?.option) {

        const metadata: CustomMetadataOperation[] = [];
        metadata.push({ key: "b64PublicKey", value: this.publicKey });
        metadata.push({ key: 'privacyPolicyAccepted', value: true });
        metadata.push({ key: 'observations', value: result?.value });
        metadata.push({ key: 'rejectOption', value: 'REVISAR' });

        await this._finishProService.putFinishOperation(false, metadata, false);

        this._router.navigate([Routes.DASHBOARD]);
      }
      sub.unsubscribe();
    });
  }

  async downloadDocuments(): Promise<void> {
    this.isLoading = true;
    this.documents.forEach(doc => {
      this.validatorDocuments(doc)
    })
    try {
      await this._finishProService.getDownloadDocumentsCircuit();
    } catch (e) {
      console.log(e);
    }
  }

  async validatorDocuments(doc: IvCertCircuitDocumentP): Promise<void> {
    if (!this._finishProService.validatorDocumentList.includes(doc)) {
      this._finishProService.validatorDocumentList.push(doc);
    }

    const metadata = [];
    metadata.push({ key: "b64PublicKey", value: this.publicKey });
    metadata.push({ key: 'privacyPolicyAccepted', value: true });

    try {
      if (this._finishProService.validatorDocumentList.length === this.documents.length) {
        await this._finishProService.putFinishOperation(true, metadata);
        this.isLoading = false;
        try {
          const route = this._finishProService.getRoutePath();
          const CUSTOM_TIMEOUT: number = 500;
          setTimeout(() => this._router.navigate([route], { relativeTo: this._route.parent }), CUSTOM_TIMEOUT);
        }
        catch (e) {
          console.log(e);
        }
      }
    }
    catch (e) {
      console.log(e);
    }
  }
}
